// extracted by mini-css-extract-plugin
export default {"form":"form___Is8iv","logo":"logo___slGFU","header":"header___endME","subheader":"subheader___lmMmn","links":"links___OKGLz","terms":"terms___a8RX0"};